export default __webpack_public_path__ + "static/media/ms_employees_icon.e6f47961.svg";